// base fields which are common for most of the entities in the backend
// and will be inherited in most data models in the frontend too

export class Entity {
  createdBy: string;
  creationDate: Date;
  modifiedBy: string;
  modifiedDate: Date;
  version: number;
  deleted: boolean;
}

export class BaseEntity<K> extends Entity {
  id: K;
}
